import { AsyncState, Maybe  } from 'ballerina-core'
import { List, Map } from "immutable";

export type FiltersState = AsyncState<Maybe<FiltersMap>>
export type FilterItem = { value: string; isSelected: boolean }

export type FilterSelect = {
  kind: "select"
  filterItems: List<FilterItem>
}

export type FilterTab = {
  kind: "tab"
  filterItems: List<FilterItem>
}

export type FilterRadio = {
  kind: "radio"
  filterItems: List<FilterItem>
}

export type FilterSearch = {
  kind: "search"
  searchQuery: string
}

export const initialFiltersState = (previousFiltersState?: FiltersState): FiltersState =>
  previousFiltersState || AsyncState.Default.unloaded()

export type FilterDate = {
  kind: "date"
  startDate?: Date
  endDate?: Date
}

export type FilterGroup =
  | FilterSelect
  | FilterRadio
  | FilterSearch
  | FilterDate
  | FilterTab

export type FiltersMap = Map<string, FilterGroup>

export type FiltersResponse = Record<string, FilterGroup>
